import { render, staticRenderFns } from "./CadastroDeTabelas.vue?vue&type=template&id=f92c03ae&"
import script from "./CadastroDeTabelas.vue?vue&type=script&lang=js&"
export * from "./CadastroDeTabelas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports